(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
window.themeCartDrawer = window.themeCartDrawer || {};

window.themeCartDrawer.forceUpdateCartStatus = async function() {
  try {
    const response = await fetch('/?section_id=cart-drawer');
    if (!response.ok) return;

    const html = await response.text();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const newCartItems = tempDiv.querySelector('.cart-items-component');
    const cartDrawerItems = document.querySelector('.cart-items-component');

    if (newCartItems && cartDrawerItems) {
      cartDrawerItems.innerHTML = newCartItems.innerHTML;
    }

    const cartBubble = document.querySelector('.cart-bubble__text-count');
    if (cartBubble) {
      const cartCountMatch = html.match(/"item_count":(\d+)/);
      const cartCount = cartCountMatch ? cartCountMatch[1] : 0;
      cartBubble.textContent = cartCount;
      cartBubble.classList.remove('hidden');
    }
  } catch (err) {
    console.error('Cart drawer update failed:', err);
  }
};

// PageFly AJAX hook
if (window._pf_ajaxCartUpdate) {
  const original = window._pf_ajaxCartUpdate;
  window._pf_ajaxCartUpdate = function(...args) {
    original.apply(this, args);
    setTimeout(() => window.themeCartDrawer.forceUpdateCartStatus(), 100);
  };
}

// Shopify AJAX cart hook
document.addEventListener('cart:updated', () => {
  window.themeCartDrawer.forceUpdateCartStatus();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
